<template>
  <header
    class="relative w-full top-0 left-0 right-0 pt-24px pb-32px mx-auto transition bg-transparent"
    :class="{'!pb-24px': singleLogo}"
  >
    <div class="max-w-600px w-full mx-auto">
      <img
          :src="require(`@/assets/images/logos/${logo}.png`)"
          alt="logo"
          class="inline-block w-120px sm:w-150px"
          :class="{'!max-w-32px !block mx-auto': singleLogo}"
      >
    </div>
  </header>
</template>

<script>

export default {
  name: 'HeaderLayout',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logo: 'logo_black',
    }
  },
  methods: {
    switchTheme(isDark) {
      setTimeout(() => {
        isDark ? this.logo = 'logo_white' : this.logo = 'logo_black'
      }, 1000)
    }
  },
  computed: {
    singleLogo() {
      return this.$versions.current.hp === 4 && this.$route.name === 'home'
    }
  },
  watch: {
    dark: {
      handler(value) {
        this.switchTheme(value)
      },
    }
  },
  mounted() {
    if (this.singleLogo) {
      this.logo = 'img_dr_logo_v0'
    } else {
      this.dark ? this.logo = 'logo_white' : this.logo = 'logo_black'
    }
  }
};
</script>
